import React from 'react';
import * as ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import styled, { keyframes } from 'styled-components';
import { RootState } from '../../../../../redux/root';

const PopupMessage = ({ caption, children }) => {
  const showPopup = useSelector((s: RootState) => s.inspections.showPopup);

  if (!showPopup) return null;

  return ReactDOM.createPortal(
    <Backdrop role="presentation">
      <Card role="dialog" aria-modal="true" aria-label={caption}>
        <Header>
          <Caption>{caption}</Caption>
        </Header>
        <Body>{children}</Body>
      </Card>
    </Backdrop>,
    document.body,
  );
};

export default PopupMessage;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const cardIn = keyframes`
  from { opacity: 0; transform: translateY(8px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(19, 23, 32, 0.45);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  animation: ${fadeIn} 0.18s ease-out;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont,
    'Helvetica Neue', Arial, Roboto, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
`;

const Card = styled.div`
  width: 100%;
  max-width: 480px;
  background: var(--neutral-0);
  border: 1px solid var(--neutral-200);
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18),
    0 8px 16px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  animation: ${cardIn} 0.22s ease-out;
  box-sizing: border-box;
`;

const Header = styled.div`
  padding: 22px 28px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Caption = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--mainText);
  letter-spacing: -0.005em;
  text-align: center;
`;

const Body = styled.div`
  padding: 16px 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    margin: 0;
    font-size: 0.9375rem;
    line-height: 1.55;
    color: var(--neutral-600);
    text-align: center;
  }

  @media only screen and (max-width: 540px) {
    padding: 14px 20px 20px;
  }
`;
